import React, {useState} from 'react';
import {Reply} from "@mui/icons-material";
import {Button, Grid, TextField} from "@mui/material";
import {API} from "../framework/api";
import {confirmAlert} from "react-confirm-alert";

export function ReplyArea(props) {
  const [showReply, setShowReply] = useState(false);
  const [reply, setReply] = useState('');

  const handleSubmitReply = () => {
    if (props.assignmentUser) {
      API.getAPI().send_empty_assignment_reply(props.assignmentUser, props.assignmentId, reply).then(() => {
        setShowReply(false);
        if (props.onChange instanceof Function) {
          props.onChange(props.assignmentId);
        }
      }).catch((e) => {
        confirmAlert({
          title: "Svaret kunde inte skickas",
          message: "Tyvärr kunde ditt svar inte skickas just nu. Vänligen försök igen lite senare.",
          buttons: [{
            label: "Avfärda",
            onClick: () => {
            }
          }]
        });
      });
    } else {
      API.getAPI().send_assignment_reply(props.assignmentId, reply).then(() => {
        setShowReply(false);
        if (props.onChange instanceof Function) {
          props.onChange(props.assignmentId);
        }
      }).catch((e) => {
        confirmAlert({
          title: "Svaret kunde inte skickas",
          message: "Tyvärr kunde ditt svar inte skickas just nu. Vänligen försök igen lite senare.",
          buttons: [{
            label: "Avfärda",
            onClick: () => {
            }
          }]
        });
      });
    }
  };

  return (
    <div>
      {showReply
        ?
        <div className={"u-marginT8"}>
          <Grid container={1}>
            <TextField
              multiline={true}
              minRows={3}
              placeholder="Skriv ditt svar..."
              style={{ minWidth: '100%' }}
              value={reply}
              onChange={(e)=> {setReply(e.target.value)}}
            />


            <Grid item xs={12} sm={12} className={"u-textRight u-marginT20"}>

              <Button
                className={"App-button-text"}
                variant={"text"}
                onClick={() => setShowReply(false)}
              >
                Avbryt
              </Button>

              <Button
                className={"App-button-contained"}
                variant={"contained"}
                onClick={handleSubmitReply}
              >
                Skicka
              </Button>
            </Grid>
          </Grid>
        </div>
        :
        <div className={"u-clickable"} onClick={() => { setShowReply(true) }}>
          <Reply />
        </div>
      }
    </div>
  );
}
